export const emailRegExpServer = /^[A-Za-z0-9_.-]+@[A-Za-z0-9]+([.-][A-Za-z0-9]+)+$/
export const noWhitespaceRegExp = /^\S*$/
